import momentTz from 'moment-timezone/builds/moment-timezone-with-data.js';

export function getBrowserTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function getTimezone(setting) {
  let tz = setting.timezone;
  if (!setting.timezone || setting.timezone === 'BaseOnBrowser') {
    tz = getBrowserTimezone();
  }
  return tz;
}

export function timezones() {
  return momentTz.tz.names();
}
